import { createApp } from 'vue';
import SvgIcon from '@/components/SvgIcon'; // svg组件

let svgIcons = [];

// 注册全局组件的方式发生了变化
export default {
  install(app) {
    // 注册全局组件
    app.component('svg-icon', SvgIcon);

    const req = require.context('./svg', false, /\.svg$/);
    const requireAll = (requireContext) =>
      requireContext.keys().map(requireContext);

    // 获取所有svg图标名称
    svgIcons = req.keys().map((filePath) => {
      // Extract the icon name from the file path
      const iconName = filePath.match(/\.\/(.*)\.svg/)[1];
      return iconName;
    });

    // 添加到全局属性
    app.config.globalProperties.$svgIcons = svgIcons;
    requireAll(req);
  },
};
